// Frontend build identifier for the stale-bundle guard. Kept in sync with the
// backend BUILD_VERSION; bump both on each release. An env override wins so a
// deploy pipeline can inject a unique value automatically.
export const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION || '1.8.5';
